export const MAIN_TEXT_FIELD_MAPPING: Record<
    string,
    {
        key: string
        displayName: string | null
        dataType: string
        elementPath: string
    }[]
> = {
    'wixEditorElements.CollapsibleText': [
        {
            key: 'text',
            displayName: null,
            dataType: 'text',
            elementPath: 'root'
        },
        {
            key: 'textDescription',
            displayName: null,
            dataType: 'text',
            elementPath: 'root'
        },
        {
            key: 'wrappingStyle',
            displayName: null,
            dataType: 'text',
            elementPath: 'root'
        },
        {
            key: 'linkText',
            displayName: null,
            dataType: 'text',
            elementPath: 'button'
        },
        {
            key: 'readLessText',
            displayName: null,
            dataType: 'text',
            elementPath: 'button'
        },
        {
            key: 'readMoreText',
            displayName: null,
            dataType: 'text',
            elementPath: 'button'
        }
    ],
    'wixEditorElements.TextMarquee': [
        {
            key: 'text',
            displayName: 'Text',
            dataType: 'text',
            elementPath: 'root'
        }
    ],
    'wixEditorElements.WRichText': [
        {
            key: 'richText',
            displayName: null,
            dataType: 'richText',
            elementPath: 'root'
        }
    ],
    'wixEditorElements.TestComp': [
        {
            key: 'text',
            displayName: null,
            dataType: 'text',
            elementPath: 'description'
        },
        {
            key: 'alt',
            displayName: null,
            dataType: 'text',
            elementPath: 'image'
        },
        {
            key: 'src',
            displayName: null,
            dataType: 'text',
            elementPath: 'image'
        },
        {
            key: 'text',
            displayName: null,
            dataType: 'text',
            elementPath: 'title'
        }
    ]
}
